import {api} from "../../shared/utils";
import {extractListPayload} from "../../shared/utils/payload";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });

    return query.toString();
};

const comQuery = (caminho, params) => {
    const query = buildQuery(params);
    return `${baseUrl}${caminho}${query ? `?${query}` : ''}`;
};

// Páginas de 100 (o máximo das APIs) até `has_next` acabar.
const todasAsPaginas = async (caminho, params = {}) => {
    const items = [];
    for (let page = 1; ; page += 1) {
        const response = await api.get(comQuery(caminho, {...params, page, pageSize: 100}));
        const pagina = extractListPayload(response).items;
        items.push(...pagina);
        const raiz = response?.data?.valor ?? response?.data?.data ?? response?.data;
        if (!pagina.length || !raiz?.pagination?.has_next) break;
    }
    return items;
};

/* ---------- plano ---------- */

export const listPlanos = (params = {}) => todasAsPaginas('/planos-licenciamento', {sortBy: 'nome_plano', order: 'asc', ...params});

export const getPlano = (id) => api.get(`${baseUrl}/planos-licenciamento/${id}`);

export const createPlano = (payload) => api.post(`${baseUrl}/planos-licenciamento`, payload);

// O PUT do plano troca o cadastro inteiro: quem chama manda o plano completo (`corpoDoPlano`).
export const updatePlano = (id, payload) => api.put(`${baseUrl}/planos-licenciamento/${id}`, payload);

/* ---------- versões (BBF-104) ---------- */

export const listVersoes = (planoId) => api.get(`${baseUrl}/planos-licenciamento/${planoId}/versoes`);

export const getVersao = (planoId, numero) => api.get(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}`);

// Rascunho novo, copiado da versão `aPartirDe` (sem ela, da à venda).
export const createRascunho = (planoId, aPartirDe) => api.post(
    `${baseUrl}/planos-licenciamento/${planoId}/versoes`,
    aPartirDe ? {a_partir_de: aPartirDe} : {},
);

export const updateRascunho = (planoId, numero, payload) => api.put(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}`, payload);

export const deleteRascunho = (planoId, numero) => api.delete(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}`);

export const publicarVersao = (planoId, numero) => api.post(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}/publicacao`);

/* ---------- catálogo, assinaturas e simulador ---------- */

export const listSistemas = () => todasAsPaginas('/sistemas', {sortBy: 'nome', order: 'asc'});

export const listModulosDoSistema = (sistemaId) => todasAsPaginas('/modulos', {sistema_id: sistemaId, sortBy: 'nome', order: 'asc'});

export const getPendenciasDoSistema = (sistemaId) => api.get(`${baseUrl}/sistemas/${sistemaId}/pendencias`);

// As assinaturas do plano (app-licencas): a tela agrupa por versão.
export const listLicencasDoPlano = (planoId) => todasAsPaginas('/licencas', {id_plano: planoId, sortBy: 'criado_em', order: 'desc'});

/*
 * Simulador da versão pelo cálculo único da fatura (BBF-24, rota da frente 2): uma assinatura hipotética desta versão,
 * com os opcionais e o desconto escolhidos. Só lê, e a versão pode estar em rascunho (salvo). Responde uma seção no
 * formato da prévia, mais `emissao` e `situacao_da_versao`.
 */
export const simularVersao = ({idPlanoVersao, opcionais = [], desconto = null, data = ''}) => api.get(
    comQuery(`/financeiro/versoes/${idPlanoVersao}/simulacao`, {
        opcionais: opcionais.join(','),
        desconto_tipo: desconto?.tipo,
        desconto_valor: desconto?.valor,
        data,
    }),
);

// Todos os recursos (endpoints) do sistema, com a funcionalidade e o módulo de cada um, para os perfis-modelo.
export const listRecursosDoSistema = async (sistemaId) => {
    const items = await todasAsPaginas('/recursos', {sistema_id: sistemaId, sortBy: 'nome', order: 'asc'});
    return {data: {items, total: items.length}};
};
